import React from "react";
import { Link } from "react-router-dom";
import { DataNav } from "../data/DataNav";

function Nav() {
  const dataNav = DataNav;

  return (
    <div>
      <div className="header-nav main-nav-one">
        <nav>
          <ul className="parent-nav">
            {/* Pacourir la dataList de nav */}
            {dataNav?.map((item) => {
              return (
                <li key={item.id}>
                  <Link className="nav-link" to={item.link}>
                    <span className="rolling-text">
                      <div className="block">
                        {/* Afficher chaque lettre de l'item.label dans une span */}
                        {item.label.split().map((letter, index) => {
                          return (
                            <span key={index} className="letter">
                              {letter.toUpperCase()}
                            </span>
                          );
                        })}
                      </div>

                      <div className="block">
                        {/* Afficher chaque lettre de l'item.label dans une span */}
                        {item.label.split().map((letter, index) => {
                          return (
                            <span key={index} className="letter">
                              {letter.toUpperCase()}
                            </span>
                          );
                        })}
                      </div>
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default Nav;
